export default __webpack_public_path__ + "static/media/dc_dumdums.76260e30.png";